import { Injectable } from '@angular/core';

import { IEventWaitingListSettings } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EventWaitingListWidgetService {
    areSettingsValid(settings: IEventWaitingListSettings): boolean {
        if (!settings) {
            return false;
        }
        return true;
    }
}
